import React, { Fragment, useState, useEffect,useRef } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import myLoader from "./loaderred.gif";
import download from "./download.png";
import { format, set } from "date-fns";
import { Button, Dropdown } from "react-bootstrap";
import { Col, Row, Container } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
const { config } = require("../src/api/api");

//  const { t } = useTranslation();
const MyStaffs = ({ usrtok }) => {
  const base_url = config.baseURL;
  const redirectURL = config.redirectURL;
 

  const [userData, setUserData] = useState(false);
  const [vendorKey, setVendorKey] = useState(null);
  const [staffDetails, setstaffDetails] = useState([]);
  const [show, setShow] = useState(false);
  const [insuranceData, setInsuranceData] = useState(null);
  const itemsPerPage = 10;
  const [totalPages, totalPagess]=useState(0);
  const [profile, setProfile] = useState(null);
  const [indexOfFirstItem, setindexOfFirstItem]= useState(0);
  const [indexOfLastItem, setIndexOfLastItem]= useState(0);
  const [currentItems, currentItemsdata]= useState([]);
  const [currentPage, setCurrentPage] = useState(1);
   const [loading, setLoading] = useState(false);

  if (!Cookies.get("userData")) {
    alert("Login Session Expired");
    window.location.href = "/";
  }

  useEffect(() => {
    debugger;

    const storedUserString = Cookies.get("userData"); //sessionStorage.getItem('userData')
    if (storedUserString !== "undefined") {
      const storedUser = JSON.parse(storedUserString);
      setUserData(storedUser);
    }
  }, []);

  usrtok = userData.access_token;

  useEffect(() => {
    debugger
    const postvData = { organization_name: "Superjet" };
    if (vendorKey === "" || vendorKey === null || vendorKey === undefined) {
      fetch(base_url + "/create_organization", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postvData),
      })
        .then((response) => response.json())
        .then((data) => {
          setVendorKey(data.result[0].vendor_key);
        })
        .catch((error) => {
          console.error("Error Getting Vendor Key:", error);
        });
    }
  }, [vendorKey]); // Dependency array

  const getStaffDetails = async (vk, token) => {
    if (userData.agency_name) {
      const Data = { token: token };
      fetch(base_url + "/get_agent_staff_details", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vk}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Data),
      })
        .then((response) => response.json())
        .then((data) => {
      if(data&&data?.message!=="success"){
      return;
      }
          setstaffDetails(data?.result);
          setProfile(data)
          const totalPagesCount = Math.ceil(data.result.length / itemsPerPage);
        totalPagess(totalPagesCount);
        debugger
        calculatePagination(currentPage,data?.result);
        })
        .catch((error) => {
          console.error("Error Getting Insurance Data:", error);
        }).finally(() => {
          setLoading(false);
        });}
  }

  useEffect(() => {
     setLoading(true);
    debugger
    if (
      (vendorKey !== "" &&
      vendorKey !== null &&
      vendorKey !== undefined )&&
      (usrtok !== "" &&
      usrtok !== null &&
      usrtok !== undefined)
    ) {
      debugger
      getStaffDetails(vendorKey, usrtok);

    }
  }, [vendorKey, usrtok]); // Dependency array

  const handleClose = () => {
    setCreatePage(false);
  };

  const handleViewDetails = async (e,staff_id) => {
    // debugger

    e.preventDefault();

    const base64_staff_id=btoa(staff_id);
    window.location.href="/staff-orders-tracking?staff_id="+base64_staff_id;
  };


//  const handleinsuranceStatus = (policy) => {
//     debugger
//     const policy_no = policy.policy_no;
//     const insurance_type = policy.insurance_type;
//     const type = policy.type; // This line might be redundant as it is the same as insurance_type
  
//     let page = '';
//     if (insurance_type === 'travel' && type === 'inbound') {
//       page = `${redirectURL}/download-policy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     } else if (insurance_type === 'travel' && type === 'outbound') {
//       page = `${redirectURL}/download-outbound-policy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     } else if (insurance_type === 'Personal Accident' && type === 'Personal Accident'
//       ) {
//       page = `${redirectURL}/personalinformation-downloadpolicy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     } else if (insurance_type === 'Personal Accident' && type === 'Term Plan') {
//       page = `${redirectURL}/termplan-downloadpolicy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     }else if (insurance_type === 'Life Insurance' && type === 'Personal Accident') {
//       page = `${redirectURL}/personalinformation-downloadpolicy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     } else if (insurance_type === 'Life Insurance' && type === 'Term Plan') {
//       page = `${redirectURL}/termplan-downloadpolicy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     }else if (insurance_type === 'Home Insurance' && type === 'Tenant') {
//       page = `${redirectURL}/home-downloadpolicy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     }else if (insurance_type === 'Home Insurance' && type === 'Owner') {
//       page = `${redirectURL}/home-downloadpolicy?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     }
//     else if (insurance_type === 'Medical Insurance' && type === 'Individual Medical') {
//       page = `${redirectURL}/medical-download?policyno=${policy_no}`;
//       window.open(page, '_blank');
//     }
//     else if (insurance_type === 'Medical Insurance' && type === 'Affordable Health Cover') {
//       page = `${redirectURL}/medicalhealth-download?policyno=${policy_no}`;
//       window.open(page, '_blank'); 
//     }
//     else if (insurance_type === 'Medical Insurance' && type === 'Unified Domestic Worker'
//       ) {
//       page = `${redirectURL}/medicalworker-download?policyno=${policy_no}`;
//       window.open(page, '_blank');
//     }
//   };

  const calculatePagination = (page,list) => {
    debugger
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfLastItem(indexOfLastItem);
    setindexOfFirstItem(indexOfFirstItem);
    const currentItem = list.slice(indexOfFirstItem, indexOfLastItem);
    currentItemsdata(currentItem);
  };
  
  const handleNextPage = () => {
    debugger
    setCurrentPage((prevPage) => {
      const newPage = prevPage < totalPages ? prevPage + 1 : prevPage;
      if(staffDetails.length > 0){
        calculatePagination(newPage,profile.result);
      }else{
        calculatePagination(newPage,staffDetails);
      }
      return newPage;
    });
  };
  
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => {
      const newPage = prevPage > 1 ? prevPage - 1 : prevPage;
      if(staffDetails . length > 0){
        calculatePagination(newPage,profile.result);
      }else{
        calculatePagination(newPage,staffDetails);
      }
      // calculatePagination(newPage,insuranceData);
      return newPage;
    });
  };






 const [createPage,setCreatePage]=useState(false)

 const handleCreate=()=>{
  setCreatePage(true)
 };

 const { t } = useTranslation();

    const [formData,setFormData]=useState({ firstname:"",lastname:"",email:"", password:"" ,confirmpassword:""});
    const [errors,setErrors]=useState({});

    const firstnameRef=useRef(null);
    const lastnameRef=useRef(null);
    const emailRef=useRef(null);
    const passwordRef=useRef(null);
    const confirmpasswordRef=useRef(null);



    const handleChange = (e) => {
    const { name, value } = e.target;
    const trimValue = value.trimStart();

    
    const nameRegex = /^[A-Za-z\s]*$/;
      
    

    if (name === "firstname" || name === "lastname") {
      if (nameRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
    }
 
    else {
      setFormData({ ...formData, [name]: trimValue });
    }
  };


    const handleValidation = () => {
  let newErrors = {};

if(!formData.firstname){
     newErrors.firstname = "First Name  Required";
}
if(!formData.lastname){
     newErrors.lastname = "Last Name  Required";
}
  if (!formData.email?.trim()) {
    newErrors.email = "Email Required";
  } else{
 const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid Email Format";
    
  }
  }
   
  if(!formData.password){
     newErrors.password = "Password  Required";
}
 if(!formData.confirmpassword){
     newErrors.confirmpassword = "Confirm Password  Required";
}else{
if(formData.password !== formData.confirmpassword){
    newErrors.confirmpassword = "Password Not Match";
}
}




  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    const firstError = Object.keys(newErrors)[0];
    switch (firstError) {
         case "firstname":
        firstnameRef.current.focus();
        break;
      case "lastname":
        lastnameRef.current.focus();
        break;
      case "email":
       emailRef.current.focus();
        break;
        case "password":
        passwordRef.current.focus();
        break;
        case "confirmpassword":
        confirmpasswordRef.current.focus();
        break;
    }
    return false;
  }

  return Object.keys(newErrors).length===0 ;
};



    
   const handleBlur=(e)=>{
    const { name } =e.target;
    if(formData[name]?.trim()){
setErrors((prev)=>({...prev,[name]:""}))
    }
    
   }

const handleSubmit=async(e)=>{
     e.preventDefault(); 

  if (handleValidation()) {
    if(!vendorKey || !usrtok){
      return;
    }
    setLoading(true);
     try {
      const response = await fetch(
        base_url+"/create_agency_staff_login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${vendorKey}`
          },
          body: JSON.stringify({
            "token": usrtok,
             "first_name": formData.firstname,
            "last_name": formData.lastname,
            "email": formData.email,
            "password": formData.password
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
debugger
      if(data.message==="Agency staff created successfully."){

        setCreatePage(false);
        toast.success(data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        
       getStaffDetails(vendorKey, usrtok);
      }else{
  toast.error(data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        
      }

    } catch (err) {

       toast.error(err.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
    
  }


  const [passwordVisible, setPasswordVisible] = useState(false);
  const [cpasswordVisible, setcPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const togglecPasswordVisibility = () => {
    setcPasswordVisible(!cpasswordVisible);
  };


useEffect(()=>{



},[])




  return (
    <>
      <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">
              {t("MY")} {t("STAFFS")}
            </h3>
          </div>
        </div>
      </div>

      <div className="features_section layout_padding my-1">
        <div className="container">
          <div className="row g-4">
              <div className="col-12 d-flex justify-content-end">
                <button
                  className="btn btn-primary text-align-end"
                  onClick={handleCreate}
                >
                 + {t("Create")} {t("Staff")}
                </button>
              </div>
            <div
              className="col-12 wow fadeInUp"
              data-wow-delay="0.2s"
              style={{ overflowX: "auto" }}
            >
            

              <table className="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      {t("Full Name")}
                    </th>

                    <th>{t("Email")}</th>
                    <th>
                       {t("Visa")}
                    </th>
                     <th>
                     {t("Insurance")}
                    </th>
                    <th>
                     {t("Lounges")}
                    </th>
                    <th>
                     {t("Hotel")}
                    </th>
                   

                    <th>{t("View")}</th>
                  </tr>
                </thead>
                <tbody>
                  {staffDetails.length <= 0 && currentItems.length <= 0 && (
                    <tr>
                      <td
                        colSpan={9}
                        className="textcenter"
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                       {t("No")} {("Records")} {("Found")}
                      </td>
                    </tr>
                  )}

                 {currentItems.length>0 && currentItems.map((staff, index) => (
    <tr key={staff.staff_id}>
      <td>{indexOfFirstItem + index + 1}</td>
      <td>{staff.staff_name}</td>
      <td>{staff.staff_email}</td>
       <td>{staff.visa_count}</td>
      <td>{staff.insurance_count || "0"}</td>
      <td>{staff.lounge_count || "0"}</td>
      <td>{staff.hotel_count || "0"}</td>

     
      {/* Add more td if needed */}
      <td>
        <Button
          variant="primary"
          style={{ fontWeight: "normal" }}
          className="btn btn-primary rounded-pill text-white py-1 px-2"
          onClick={(e) => handleViewDetails(e,staff.staff_id)} // pass staff id
        >
          {t("View")} {t("Details")}
        </Button>
      </td>
    </tr>
  ))}
                </tbody>
              </table>

              {totalPages === 0 ? (
                <div></div>
              ) : (
                <div className="pagination-controls-new">
                  <button onClick={handlePrevPage} disabled={currentPage === 1}>
                    ‹
                  </button>
                  <span></span>
                  <span>
                    {t("Page")} {currentPage} {t("of")} {totalPages}
                  </span>
                  <span></span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    ›
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <ToastContainer
              position="top-right" // default
              autoClose={5000} // 3 sec
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              pauseOnHover
              draggable
              theme="colored" // or "dark", "colored"
            />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      {createPage && (
        <div className="modal" >
          <div
            className="card p-4  m-1" style={{width:"600px"}}
          >
            <h2 >
              <span>{t("Create")} {t("Staff")}</span>
            </h2>
            <button type="button" className="close" onClick={handleClose}>
              &times;
            </button>
           
            <div>
              
                <form  className="mt-2">
                  
                    <div className="input-group mb-2 ">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        {t("First")} {t("Name")}
                      </span>
                    </div>
                    <input
                      type="text"
                      name="firstname"
                      ref={firstnameRef}
                      className="form-control"
                      value={formData?.firstname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
               
                  </div>
                            {errors.firstname && (
                    <span style={{ color: "red",textAlign:"left" }}>{errors.firstname}</span>
                  )} 
                  
                  
              
                  <div className="input-group mb-2 ">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        {t("Last")} {t("Name")}
                      </span>
                    </div>
                    <input
                      type="text"
                      name="lastname"
                      ref={lastnameRef}
                      className="form-control"
                      value={formData?.lastname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  {errors.lastname && (
                    <span style={{ color: "red" }}>{errors.lastname}</span>
                  )}

                  <div className="input-group mb-2 ">
                    <div className="input-group-prepend">
                      <span className="input-group-text">{t("Email")}</span>
                    </div>
                    <input
                      type="email"
                      name="email"
                      ref={emailRef}
                      className="form-control"
                      value={formData?.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  {errors.email && (
                    <span style={{ color: "red" }}>{errors.email}</span>
                  )}
                  <div className="input-group mb-2 ">
                    <div className="input-group-prepend">
                      <span className="input-group-text">{t("Password")}</span>
                    </div>
                    <input
                      type={passwordVisible ? "text" : "password"}
                      name="password"
                      ref={passwordRef}
                      className="form-control"
                      value={formData?.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        className="btn btn-outline-grey"
                        onClick={togglePasswordVisibility}
                      >
                        {passwordVisible ? (
                          <i className="fas fa-eye"></i>
                        ) : (
                          <i className="fas fa-eye-slash"></i>
                        )}
                      </button>
                    </div>
                  </div>
                  {errors.password && (
                    <span style={{ color: "red" }}>{errors.password}</span>
                  )}
                  <div className="input-group mb-2 ">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        {t("Confirm")} {t("Password")}
                      </span>
                    </div>
                    <input
                      type={cpasswordVisible ? "text" : "password"}
                      name="confirmpassword"
                      className="form-control"
                      ref={confirmpasswordRef}
                      value={formData?.confirmpassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        className="btn btn-outline-grey"
                        onClick={togglecPasswordVisibility}
                      >
                        {cpasswordVisible ? (
                          <i className="fas fa-eye"></i>
                        ) : (
                          <i className="fas fa-eye-slash"></i>
                        )}
                      </button>
                    </div>
                  </div>
                  {errors.confirmpassword && (
                    <span style={{ color: "red" }}>
                      {errors.confirmpassword}
                    </span>
                  )}

                  <div className="d-flex  justify-content-end mt-4">
              <button
                type="button"
                class="btn btn-primary my-2 py-1 px-3 ml-3"
                aria-label="Close"
                onClick={handleClose}
              >
                {t("Cancel")}
              </button>
                    <button
                    type="button"
                      className="btn btn-primary  my-2 py-1 px-3 ml-3"
                      onClick={(e) => handleSubmit(e)}
                    >
                      {t("Submit")}
                    </button>

                  </div>
                </form>
              
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default MyStaffs;
